<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <h2>Esercizi</h2>
        <v-btn color="primary" size="small" @click="$router.push('/exercises/new')">Nuovo</v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-text-field  v-model="query.title" label="Titolo" clearable></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="exercises" view-sub-path="" :viewable="false" :editable="true" deletable :query="query" @error="onListError">
          <template v-slot:item.title.it="{ item }">
            <a @click="$router.push('/exercises/'+item._id)" ><strong>{{ item.title.it }}</strong></a>
          </template>

          <template v-slot:item.pub="{ item }">
            <strong class="text-success" v-if="item.pub">Sì</strong>
            <span class="text-error" v-else>No</span>
          </template>

        </data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject, onBeforeUnmount, useTemplateRef} from 'vue'
import { useRouter } from 'vue-router'
import utils from '../utils'
import DataTable from "@/components/DataTable.vue";
import {type DataTableError, type Query} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import type {Globals} from "@/plugins/globals.ts";


export default defineComponent({
  components: {DataTable},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const router = useRouter()
    const dataTable = useTemplateRef<typeof DataTable>('dataTable')
    const query = ref<Query>({})


    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit
      /*
      await Promise.all([
        globals.refresh('categories'),
        globals.refresh('difficulties'),
      ])*/
      query.value = utils.getSessionQuery("exercises")
      wh = watch(query.value, ()=>{
        utils.setSessionQuery("exercises", query.value)
      }, { deep: true })
    })
    onBeforeUnmount(()=>{
      if(wh) wh();
    })
    return {
      dataTable,
      formatDateTime : utils.formatDateTime,
      query,
      headers : [
        { title : 'Titolo', sortable: true, align: 'left', value : 'title.it' },
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
    }
  }
})
</script>
